import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AccountClientDetailsService } from './../../../../../account-client/service/account-client-edit/account-client-details.service';
import { CommonService } from '../../../../../common/service/common.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';
import 'moment/locale/pt-br';
import { GuaranteeType } from '../../../../../models/guarantee-type';
import { IMyDpOptions } from 'mydatepicker';

export interface InsertGuaranteeModal {
	client: any[];
	guaranteeObj: {};
}

@Component({
	selector: 'insert-guarantee-modal',
	templateUrl: './insert-guarantee-modal.component.html',
	styleUrls: ['./insert-guarantee-modal.component.scss'],
	providers: [
		AccountClientDetailsService,
		CommonService
	]
})

export class InsertGuaranteeModalComponent extends DialogComponent<InsertGuaranteeModal, boolean> implements InsertGuaranteeModal {

	token;

	client: any[];
	states: any[] = [];
	citys: any[] = [];

	guaranteeObj: {};

	public guarantee = {
		ID: '',
		ValorGarantia: '',
		ValorGarantido: '',
		Vigencia: {},
		VigenciaFim: {},
		DataPagamento: {},
		Motivo: '',
		Observacao: '',
		Grau: '',
		Matricula: '',
		TipoImovel: '0',
		Cidade: '0',
		Uf: '0',
		Registro: '',
		Laudo: '',
		ValorForcada: '',
		ValorMercado: '',
		Produto: '',
		Quantidade: '',
		Empresa: '',
		Area: '',
		Monitoramento: '',
		EmpresaMonitoramento: '',
		OutrasGarantias: '',
		TipoGarantia: 0,
		Status: '0',
		Ativo: true,
		ContaClienteID: '',
		DescricaoOutros: '',
		ParticipanteGarantia: [],
		ResponsavelGarantia: []
	}

	public garantido: {} = {
		Nome: '',
		Documento: ''
	};

	public garantidor: {} = {
		Nome: '',
		Documento: ''
	};

	public responsavel: {} = {
		Nome: '',
		Documento: ''
	};

	public TipoGarantia: string = "0";

	public guaranteeType: GuaranteeType;

	public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	//public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	public cnpjMask = [/[A-Za-z0-9]/,  /[A-Za-z0-9]/, '.', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.', /[A-Za-z0-9]/,
                      /[A-Za-z0-9]/, /[A-Za-z0-9]/,'/', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-', /[A-Za-z0-9]/,/[A-Za-z0-9]/,];
	private today = moment();

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

	constructor(dialogService: DialogService, private accountClientDetailsService: AccountClientDetailsService,
		private flashMessagesService: FlashMessagesService,
		private commonService: CommonService) {
		super(dialogService);
	}

	ngOnInit() {
		if (this.guaranteeObj) {

			if (this.guaranteeObj['Vigencia']) {
				const tempVigencia = moment(this.guaranteeObj['Vigencia']);
				var vigencia = { date: { year: tempVigencia.year(), month: tempVigencia.month() + 1, day: tempVigencia.date() } };
			}

			if (this.guaranteeObj['VigenciaFim']) {
				const tempVigenciaFim = moment(this.guaranteeObj['VigenciaFim']);
				var vigenciaFim = { date: { year: tempVigenciaFim.year(), month: tempVigenciaFim.month() + 1, day: tempVigenciaFim.date() } };
			}

			if (this.guaranteeObj['DataPagamento']) {
				const tempDataPagamento = moment(this.guaranteeObj['DataPagamento']);
				var dataPagamento = { date: { year: tempDataPagamento.year(), month: tempDataPagamento.month() + 1, day: tempDataPagamento.date() } };
			}

			// Edição
			this.guarantee = {
				ID: this.guaranteeObj['ID'],
				ValorGarantia: this.guaranteeObj['ValorGarantia'],
				ValorGarantido: this.guaranteeObj['ValorGarantido'],
				Vigencia: vigencia ? vigencia : null,
				VigenciaFim: vigenciaFim ? vigenciaFim : null,
				DataPagamento: dataPagamento ? dataPagamento : null,
				Motivo: this.guaranteeObj['Motivo'],
				Observacao: this.guaranteeObj['Observacao'],
				Grau: this.guaranteeObj['Grau'],
				Matricula: this.guaranteeObj['Matricula'],
				TipoImovel: this.guaranteeObj['TipoImovel'],
				Cidade: '',
				Uf: '',
				Registro: this.guaranteeObj['Registro'],
				Laudo: this.guaranteeObj['Laudo'],
				ValorForcada: this.guaranteeObj['ValorForcada'],
				ValorMercado: this.guaranteeObj['ValorMercado'],
				Produto: this.guaranteeObj['Produto'],
				Quantidade: this.guaranteeObj['Quantidade'],
				Empresa: this.guaranteeObj['Empresa'],
				Area: this.guaranteeObj['Area'],
				Monitoramento: this.guaranteeObj['Monitoramento'],
				EmpresaMonitoramento: this.guaranteeObj['EmpresaMonitoramento'],
				OutrasGarantias: this.guaranteeObj['OutrasGarantias'],
				TipoGarantia: 0,
				Status: this.guaranteeObj['Status'],
				Ativo: this.guaranteeObj['Ativo'],
				ContaClienteID: this.guaranteeObj['ContaClienteID'],
				DescricaoOutros: this.guaranteeObj['DescricaoOutros'],
				ParticipanteGarantia: this.guaranteeObj['ParticipanteGarantia'].slice(),
				ResponsavelGarantia: this.guaranteeObj['ResponsavelGarantia'].slice()
			};

			this.TipoGarantia = this.guaranteeObj['TipoGarantia'];
		}

		this.guaranteeType = new GuaranteeType();
		this.getState();
	}

	mask(): any {
		return {
			mask: (value) => {
				value = value.replace(/[^a-zA-Z0-9]+/g, '');
				if (value.length < 12)
					return this.cpfMask;
				else
					return this.cnpjMask;
			}
		};
	}

	getState() {
		this.commonService.getState(this.token).subscribe(result => {
			if (result.Success) {
				this.states = result.Result;

				if (this.guaranteeObj) {
					for (var i = 0; i < this.states.length; i++) {
						if (this.states[i].Nome === this.guaranteeObj['Uf']) {
							this.guarantee['Uf'] = this.states[i].ID;
							this.getCity(this.states[i].ID, true);
						}
					}
				}				
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getCity(stateID, load) {
		this.commonService.getCity(this.token, stateID).subscribe(result => {
			if (result.Success) {
				this.citys = result.Result;

				if (this.guaranteeObj && load) {
					for (var i = 0; i < this.citys.length; i++) {
						if (this.citys[i].Nome === this.guaranteeObj['Cidade']) {
							this.guarantee['Cidade'] = this.citys[i].ID;
						}
					}
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	clearGuarantee() {
		if (!this.guaranteeObj) {
			this.guarantee = {
				ID: '',
				ValorGarantia: '',
				ValorGarantido: '',
				Vigencia: {},
				VigenciaFim: {},
				DataPagamento: {},
				Motivo: '',
				Observacao: '',
				Grau: '',
				Matricula: '',
				TipoImovel: '0',
				Cidade: '0',
				Uf: '0',
				Registro: '',
				Laudo: '',
				ValorForcada: '',
				ValorMercado: '',
				Produto: '',
				Quantidade: '',
				Empresa: '',
				Area: '',
				Monitoramento: '',
				EmpresaMonitoramento: '',
				OutrasGarantias: '',
				TipoGarantia: 0,
				Status: '0',
				Ativo: true,
				ContaClienteID: '',
				DescricaoOutros: '',
				ParticipanteGarantia: [],
				ResponsavelGarantia: []
			};

			// insert the current client as Garantido
			var currentClient = {
				Documento: this.client['Documento'],
				Nome: this.client['Nome'],
				Garantido: true
			}

			this.guarantee.ParticipanteGarantia.push(currentClient);
		}
	}

	addGarantido(garantido) {
		var exists = false;

		for (var key in this.guarantee.ParticipanteGarantia) {
			var obj = this.guarantee.ParticipanteGarantia[key];
			if (obj.Garantido && obj.Documento === garantido.Documento.replace(/[^a-zA-Z0-9]+/g, '')) {
				exists = true;
			}
		}

		if (!exists) {
			var objGarantido = {
				Nome: garantido.Nome,
				Documento: garantido.Documento.replace(/[^a-zA-Z0-9]+/g, ''),
				Garantido: true
			}

			this.guarantee.ParticipanteGarantia.push(objGarantido);
			this.garantido = [];
		} else {
			this.flashMessagesService.show("Garantido já cadastrado", { cssClass: 'alert-danger', timeout: 6000 });
		}

	}

	removeGarantido(index) {
		delete this.guarantee.ParticipanteGarantia[index];
		this.guarantee.ParticipanteGarantia = this.guarantee.ParticipanteGarantia.filter(item => item);
	}

	addGarantidor(garantidor) {
		var exists = false;

		for (var key in this.guarantee.ParticipanteGarantia) {
			var obj = this.guarantee.ParticipanteGarantia[key];
			if (!obj.Garantido && obj.Documento === garantidor.Documento.replace(/[^a-zA-Z0-9]+/g, '')) {
				exists = true;
			}
		}

		if (!exists) {
			var objGarantidor = {
				Nome: garantidor.Nome,
				Documento: garantidor.Documento.replace(/[^a-zA-Z0-9]+/g, ''),
				Garantido: false
			}

			this.guarantee.ParticipanteGarantia.push(objGarantidor);
			this.garantidor = [];
		} else {
			this.flashMessagesService.show("Garantidor já cadastrado", { cssClass: 'alert-danger', timeout: 6000 });
		}

	}

	removeGarantidor(index) {
		delete this.guarantee.ParticipanteGarantia[index];
		this.guarantee.ParticipanteGarantia = this.guarantee.ParticipanteGarantia.filter(item => item);
	}

	getLcProposal(proposalID) {
		// STUB?
	}

	getName(type) {
		var value = null;

		if (type === 'garantido') {
			value = this.garantido['Documento'] ? this.garantido['Documento'].replace(/[^a-zA-Z0-9]+/g, '') : null;
			this.garantido['Nome'] = "";
		} else if (type === 'garantidor') {
			value = this.garantidor['Documento'] ? this.garantidor['Documento'].replace(/[^a-zA-Z0-9]+/g, '') : null;
			this.garantidor['Nome'] = "";
		} else if (type === 'responsavel') {
			value = this.responsavel['Documento'] ? this.responsavel['Documento'].replace(/[^a-zA-Z0-9]+/g, '') : null;
		}

		if (value) {
			if (value.replace(/[^a-zA-Z0-9]+/g, '').length === 11 || value.replace(/[^a-zA-Z0-9]+/g, '').length === 14) {
				this.accountClientDetailsService.searchNameByDoc(value).subscribe(result => {
					if (result.Success) {
						if (type === 'garantido') {
							this.garantido['Nome'] = result.Result[0] ? result.Result[0].Nome : "";
						} else if (type === 'garantidor') {
							this.garantidor['Nome'] = result.Result[0] ? result.Result[0].Nome : "";
						} else if (type === 'responsavel') {
							this.responsavel['Nome'] = result.Result[0] ? result.Result[0].Nome : "";
						}
					} else {
						this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
					}
				}, error => {
					console.log(error);
				});
			}
		}
	}

	addResponsavelGarantia(responsavel, tipoGarantia) {
		var exists = false;

		for (var key in this.guarantee.ResponsavelGarantia) {
			var obj = this.guarantee.ResponsavelGarantia[key];
			if (obj.Documento === responsavel.Documento) {
				exists = true;
			}
		}

		if (!exists) {
			switch (tipoGarantia) {
				case '2':
					responsavel.TipoResponsabilidade = 'PI';
					break;
				case '3':
					responsavel.TipoResponsabilidade = 'FD';
					break;
				case '4':
					responsavel.TipoResponsabilidade = 'PI';
					break;
				case '5':
					responsavel.TipoResponsabilidade = 'FD';
					break;
				case '6':
					responsavel.TipoResponsabilidade = 'CO';
					break;
			}

			this.guarantee.ResponsavelGarantia.push(responsavel);
			this.responsavel = [];
		} else {
			this.flashMessagesService.show("Responsável já cadastrado", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	removeResponsavel(index) {
		delete this.guarantee.ResponsavelGarantia[index];
		this.guarantee.ResponsavelGarantia = this.guarantee.ResponsavelGarantia.filter(item => item);
	}

	save() {
		this.guarantee.ContaClienteID = this.client['ID'];
		this.guarantee.TipoGarantia = Number(this.TipoGarantia);

		// get state name
		for (var state in this.states) {
			var objState = this.states[state];
			if (this.guarantee.Uf === objState.ID) {
				this.guarantee.Uf = objState.Nome;
			}

		}

		// get city name
		for (var city in this.citys) {
			var objCity = this.citys[city];
			if (this.guarantee.Cidade === objCity.ID) {
				this.guarantee.Cidade = objCity.Nome;
			}
		}

		// format date fields
		this.guarantee.Vigencia = this.guarantee.Vigencia && this.guarantee.Vigencia['date'] ? this.guarantee.Vigencia['date'].year + "-" + this.guarantee.Vigencia['date'].month + "-" + this.guarantee.Vigencia['date'].day : null;
		this.guarantee.VigenciaFim = this.guarantee.VigenciaFim && this.guarantee.VigenciaFim['date'] ? this.guarantee.VigenciaFim['date'].year + "-" + this.guarantee.VigenciaFim['date'].month + "-" + this.guarantee.VigenciaFim['date'].day : null;
		this.guarantee.DataPagamento = this.guarantee.DataPagamento && this.guarantee.DataPagamento['date'] ? this.guarantee.DataPagamento['date'].year + "-" + this.guarantee.DataPagamento['date'].month + "-" + this.guarantee.DataPagamento['date'].day : null;

		console.log("GUARANTEE:", this.guarantee);

		if (this.guaranteeObj) {
			// Atualiza a Garantia
			this.accountClientDetailsService.updateClientGuarantee(this.guarantee).subscribe(result => {
				if (result.Success) {
					this.result = true;
					this.close();
					this.flashMessagesService.show("Garantia atualizada com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		} else {
			// Salva a Garantia
			this.accountClientDetailsService.saveClientGuarantee(this.guarantee).subscribe(result => {
				if (result.Success) {
					this.result = true;
					this.close();
					this.flashMessagesService.show("Garantia cadastrada com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
	}

	testarVigencia() {
		const vigencia = this.guarantee.Vigencia ? moment(this.guarantee.Vigencia['jsdate']) : null;
		const vigenciaFim = this.guarantee.VigenciaFim ? moment(this.guarantee.VigenciaFim['jsdate']) : null;
		return vigencia > vigenciaFim;
	}

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/guarantees-account-client/insert-guarantee-account-client/insert-guarantee-modal.component.ts